import {
  DependencyList,
  Dispatch,
  SetStateAction,
  createContext,
  useEffect,
  useContext,
} from 'react';

export type BreadcrumbItem = {
  text?: string;
  urlPart?: string;
  hidden?: boolean;
};

type BreadcrumbContextType = [BreadcrumbItem[], Dispatch<SetStateAction<BreadcrumbItem[]>>];

export const BreadcrumbContext = createContext<BreadcrumbContextType>([[], () => null]);

/**
 * Helper hook to set current page breadcrumbs as an array of url parts.
 * Current organization and workspace does not need to be set as it will be added automatically.
 *
 * @example
 * useBreadcrumbs(() => [{ urlPart: 'processes', text: 'Processes' }, { urlPart: 'foo', text: 'Foo' }], [])
 */
export const useBreadcrumbs = (getRoutes: () => BreadcrumbItem[], dependencies: DependencyList) => {
  const [, setBreadcrumbs] = useContext(BreadcrumbContext);

  useEffect(() => {
    const items = getRoutes();
    setBreadcrumbs(items);

    return () => {
      setBreadcrumbs([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};
